import TambahRegistrasiBarangJadi from './TambahRegistrasiBarangJadi';

export default TambahRegistrasiBarangJadi;
